import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation } from "react-query";

export interface Vars {
  email: string;
  first_name: string;
  last_name: string;
  timezone: string;
  country: string;
  phone_number?: string;
  phone_country_code?: string;
  npi?: string;
  us_licenses?: string[];
}

export interface InvitePhysicianResponse {
  email: string;
  first_name: string;
  last_name: string;
  timezone: string;
  country: string;
}

const useInvitePhysician = () =>
  useMutation(async (data: Vars) => {
    const response = await api.call("/invitations/physician", { method: "POST", data, root: supportApiBase });
    return response.json() as Promise<InvitePhysicianResponse>;
  });

export default useInvitePhysician;
